<template>
  <div class="container cpo-footer">
    <img src="/img/logo-2.png" class="mb-md-6" />
    <div class="layout flex-wrap flex-column">
      <div class="d-none d-md-flex">
        <v-spacer />
        <div>
          <template v-for="(lang, i) in languages">
            <a class="cpo-lang" :key="lang.value" @click="changeLocale(lang)">{{ lang.text }}</a>
            <span :key="`|_${i}`" v-if="i + 1 < languages.length">|</span>
          </template>
        </div>
      </div>
      <div class="links">
        <div class="flex d-md-flex mb-md-6">
          <a href="https://beian.miit.gov.cn/" class="mx-md-6">京ICP备2023011308号</a>
          <a href="#" class="mx-md-6">京网文(2021)2394-665号</a>
          <a href="#" class="mx-md-6">京公安网备11010202009056号</a>
        </div>
        <v-spacer />
        <div class="d-flex align-center">
          <a href="#" class="sms"><img src="/img/weibo.png" /></a>
          <a href="#" class="sms"><img src="/img/xhs.png" /></a>
          <a href="#" class="sms"><img src="/img/wechat@2x.png" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { languages } from "@/i18n";

export default {
  data() {
    return {
      languages
    };
  },
  methods: {
    changeLocale(lang) {
      this.$i18n.locale = lang.value;
      this.$moment.locale(lang.value);
    }
  }
};
</script>

<style lang="scss">
.cpo-footer {
  margin-top: 96px;
  font-size: 14px;
  > img {
    display: none;
  }
  .links {
    display: flex;
    flex-direction: column;
    a {
      display: block;
      flex: 1 0 100%;

      text-align: center;
      &.sms {
        flex: 1 0 auto;
        > img {
          width: 36px;
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .cpo-footer {
    line-height: 1;
    > img {
      display: block;
    }
    .links {
      flex-wrap: nowrap;
      flex-direction: row;
      align-items: flex-end;
      flex: 1 0 0%;
      a {
        flex: 1 0 0%;
        &.sms {
          margin: 0 16px;
          > img {
            width: 64px;
          }
        }
      }
    }
  }
}
</style>
